import { render, staticRenderFns } from "./LalamoveEditOrder.vue?vue&type=template&id=2ca0cdf5&"
import script from "./LalamoveEditOrder.vue?vue&type=script&lang=js&"
export * from "./LalamoveEditOrder.vue?vue&type=script&lang=js&"
import style0 from "./LalamoveEditOrder.vue?vue&type=style&index=0&id=2ca0cdf5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports